// extracted by mini-css-extract-plugin
export default {"footerMenuBar":"Footer_footerMenuBar__gmXbp","footerMenu":"Footer_footerMenu__YGikf"};